$(function(){

	var $showMore = $('span[id*="more-"]')
		.html('<div class="text-center"><div class="btn read-more-button">Lees meer</div></div>');

	$readmorelayer = $('<div class="read-more-layer"></div>');
	$showMore.before($readmorelayer);
	var $showMoreNext = $showMore.nextAll().wrapAll('<div class="read-more-container"></div>').parent();
	$showMoreNext.hide();
	$showMore.on('click', function() { 
		$readmorelayer.fadeOut();
		$showMore.fadeOut();
		$showMoreNext.slideToggle();
	});

});